$(function() {
  $.ajax({
    url: 'https://cdn.shopify.com/s/files/1/0343/2824/8459/files/storesTechnoCol_-_copia_72aae2c5-0753-4eae-a636-bc5ef527c41d.csv?v=1679586640',
    dataType: 'text',          
    scriptCharset: "UTF-8",
  }).done(getStore);
});

var array = [], lng = 4.60971, lat = -74.08175;
var map_store, marker_store;

function getStore(data) {
  var country = 'Colombia';
  var city, name_store, state = 0, html;
  
  if(country != null){
    
    var allRows = data.split(/\r?\n|\r/);
    
    for (var singleRow = 0; singleRow < allRows.length; singleRow++) {
      
      var rowCells = allRows[singleRow].split(';');
      if(rowCells[0] != null && rowCells[7] != undefined){
        
        if(rowCells[7] == country || quitarAcentos(rowCells[7].toUpperCase()) == quitarAcentos(country.toUpperCase())) {
          
          var name_final = rowCells[4];
          
          if(array.length == 0){
            
            var a = {
              city: name_final, 
              data: []
            }

            var data = {
              name: rowCells[0],
              mobile: rowCells[1] + ' ' + rowCells[11],
              email: rowCells[2],
              direction: rowCells[3],
              lat: rowCells[5],
              lng: rowCells[6],
              lv: rowCells[8],
              service: rowCells[9],
              img: rowCells[10]
            }

            a['data'].push(data);
            array.push(a);
            
          }else{
            
            state = 0;
            
            for (var singleRow2 = 0; singleRow2 < array.length; singleRow2++) {
              if(name_final == array[singleRow2]['city']){
                
                var data = {
                  name: rowCells[0],
                  mobile: rowCells[1] + ' ' + rowCells[11],
                  email: rowCells[2],
                  direction: rowCells[3],
                  lat: rowCells[5],
                  lng: rowCells[6],
                  lv: rowCells[8],
                  service: rowCells[9],
                  img: rowCells[10]
                }
                
                array[singleRow2]['data'].push(data);
                state = 1;
              }
             }
            
             if(state == 0){
               
                var a = {
                  city: name_final, 
                  data: []
                }
                
                var data = {
                    name: rowCells[0],
                    mobile: rowCells[1] + ' ' + rowCells[11],
                    email: rowCells[2],
                    direction: rowCells[3],
                    lat: rowCells[5],
                    lng: rowCells[6],
                    lv: rowCells[8],
                    service: rowCells[9],
                    img: rowCells[10]
                  }
                
                a['data'].push(data);
               array.push(a);
             }
           }
         }
       }
    }
    
   for (var singleRow = 0; singleRow < array.length; singleRow++) {
     
     var name_store = "<ul class='dropdown-menu dropdown-menu-right'>";
          
     city = "<div class='dropdown'><button id='"+ singleRow +"' class='drop-tiendas btn-tiendas dropdown-toggle' type='button' data-toggle='dropdown'>"+ array[singleRow]['city'] +"<span class='caret'></span></button>";
     
     for (var singleRow2 = 0; singleRow2 < array[singleRow]['data'].length; singleRow2++) {
       	 name_store = name_store + "<li id='" + singleRow2 +"'><a>" + array[singleRow]['data'][singleRow2]['name'] + "</a></li>";
   	  }
     
     if(singleRow == 0){
     	html = city + name_store + "</ul></div>";
     }else{
      html = html + city + name_store + "</ul></div>"; 
     }
    }
    
    $("#list_store").html(html);
    
    $('#title-store').html(array[0]['data'][3]['name']);
    $('#direction-store').html('<li>' + array[0]['data'][3]['direction'] + '</li>');
    $('#email-store').html('<li>' + array[0]['data'][3]['email'] + '</li>');
     
    if(array[0]['data'][3]['mobile'] != ' '){
    	$('#mobile-store').html('<li>' + array[0]['data'][3]['mobile'] + '</li>');
    }
    
    if(array[0]['data'][3]['service'] != ' '){
    	$('#service-store').html('<li>' + array[0]['data'][3]['service'] + '</li>');
    }
    
    $('#lv-store').html('<li>' + array[0]['data'][3]['lv'] + '</li>');
    
    $('#img-store').html('<img class="img-tiendas" src="'+ array[0]['data'][3]['img'] +'">');
    
    lat = array[0]['data'][3]['lat'];
    lng = array[0]['data'][3]['lng'];
    
    // Actualizar mapa con Leaflet
    var newLatLng = [parseFloat(lat), parseFloat(lng)];
    marker_store.setLatLng(newLatLng);
    map_store.setView(newLatLng, map_store.getZoom());
  }
}

$(document).ready(function(){
  // Inicializar mapa al cargar
  initMap();

  $('body').on('click', '#list_store li', function(){
      $('#title-store').html(array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['name']);
      $('#direction-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['direction'] + '</li>');
      $('#email-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['email'] + '</li>');
      
      if(array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['mobile'] != ' '){
        $('#mobile-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['mobile'] + '</li>');
      }
      
      $('#lv-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['lv'] + '</li>');
      
      if(array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['service'] != ' '){
        $('#service-store').html('<li>' + array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['service'] + '</li>');
      }
      
      $('#img-store').html('<img class="img-tiendas" src="'+ array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['img'] +'">');
      
      // Actualizar mapa con Leaflet
      lat = array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['lat'];
      lng = array[$(this).parent().siblings('button').attr('id')]['data'][$(this).attr('id')]['lng'];
      var newLatLng = [parseFloat(lat), parseFloat(lng)];
      marker_store.setLatLng(newLatLng);
      map_store.setView(newLatLng, map_store.getZoom());
  	});
});

function quitarAcentos(cadena){
	const acentos = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};
	return cadena.split('').map( letra => acentos[letra] || letra).join('').toString();	
}

function initMap() {
  // Inicializar mapa Leaflet
  map_store = L.map('map-store').setView([lat, lng], 12);
  
  // Añadir capa de OpenStreetMap
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(map_store);

  // Crear marcador inicial
  marker_store = L.marker([lat, lng]).addTo(map_store);
}